module.exports = __webpack_public_path__ + "img/puente.f72fc3ff.png";